import { render } from "./Article.vue?vue&type=template&id=d936f91e&lang=pug"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=d936f91e&lang=scss"
script.render = render

export default script